<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          title="قائمة اجراءات الطلب"
          text="قائمة بتفاصيل الاجراءات التي تم ارسالها او استلامها مسبقاً"
        >
          <v-data-table
                  :loading="isloading"
                  :loading-text="loadingtext"
                  :headers="headers"
                  :search="fullname"
                  :items="items"
          >
            <template v-slot:top
            >

              <v-container>
                <v-row>
                  <v-col cols="12" md="4" xs="12" sm="12">
                    <v-btn large color="green" dark class="mb-2" @click="addNewAction">إضافة طلب جديد</v-btn>
                  </v-col>
                  <v-col cols="12" md="8" xs="12" sm="12">
                    <v-text-field
                            filled
                            v-model="fullname"
                            append-icon="mdi-magnify"
                            label="بحث ..."
                            single-line
                            v-on:key.enter="getActions"
                            hide-details></v-text-field>
                  </v-col>
                </v-row>
              </v-container>

            </template>


            <template v-slot:item.action="{ item }">

              <v-btn
                      warning
                     dark
                     @click="deleteItem(item)">
              <v-icon
                      medium
              >
                mdi-delete
              </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
//import Axios from 'axios'
import {__HTTP,FormHeader,__HAS_PERM} from "@/utils/utils";
export default {
  methods: {

    getActions: function() {
      if (this.$route.params.id) {
      __HTTP("?do=getactions&id="+this.$route.params.id,{},FormHeader,(res) => {
        this.isloading = false
        this.items =  res;
      })} else {
        __HTTP("?do=getactions",{},FormHeader,(res) => {
          this.isloading = false
          this.items =  res;
        })
      }

    },

    addNewAction() {
            this.$router.push({name: 'NewAction', params: { id: this.$route.params.id }})
    },
    deleteItem (item) {
      const index = this.items.indexOf(item)
      let c = confirm('Are you sure you want to delete this item?');
      if (c) {
        __HAS_PERM(35,this.$store.state.loggedUser.id,() => {
          __HTTP("?do=delete",{type: "action",id: item.id},FormHeader,() => {
            this.items.splice(index, 1)
          })
        });
      }
    },
  },
  created() {this.getActions()},
  data: () => ({
    sentfrom: '',
    addby: '',
    adddate: '',
    fullname: '',
    fixed: '',
    isloading: true,
    loadingtext: "يرجى الانتظار جاري تحميل البيانات",
    dialog: false,
    toBeEdit: null,
    cards: [],
    headers: [
      {
        sortable: true,
        text: 'الإسم',
        value: 'fullname',
        align: 'right'
      },
      {
        sortable: true,
        text: 'رقم العينة',
        value: 'barcode',
        align: 'right'
      },
      {
        sortable: true,
        text: 'من',
        value: 'sentfrom',
        align: 'right'
      },
      {
        sortable: true,
        text: 'الى',
        value: 'dst',
        align: 'right'
      },
      {
        sortable: true,
        text: 'السبب',
        value: 'reason',
        align: 'right'
      },
      {
        sortable: true,
        text: 'الملاحظات',
        value: 'notes',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اضيفت بتاريخ',
        value: 'adddate',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اضيفت بواسطة',
        value: 'addby',
        align: 'right'
      },
      { text: 'الادوات', value: 'action', sortable: false },
    ],
    items: []
  })
}
</script>
